import React from 'react';
import IndexPageTemplate from '../templates/pages';
import { graphql } from 'gatsby';

export const query = graphql`
  query IndexPageQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      surgeonName
      title
      description
      keywords
    }
    reviews: allSanityReview {
      nodes {
        name
        reviewMessages
        reviewStars
      }
    }
    modelPhotos: allSanityMainPagePhoto(sort: { fields: orderRank, order: ASC }) {
      nodes {
        orderRank
        photo {
          asset {
            gatsbyImageData
          }
          alt
        }
      }
    }
    surgeryTypes: allSanitySurgeryType(
      filter: {}
      limit: 6
      sort: { order: ASC, fields: orderRank }
    ) {
      nodes {
        title
        Icon {
          asset {
            gatsbyImageData
          }
        }
        riveAnimation {
          asset {
            url
          }
        }
        _id
        link
        desc {
          children {
            text
          }
        }
      }
    }
    elena: file(base: { eq: "Elena.png" }) {
      childImageSharp {
        gatsbyImageData
      }
    }
    videos: allSanityResults {
      nodes {
        _id
        video {
          asset {
            url
          }
        }
      }
    }
  }
`;

const IndexPage = (props) => {
  const { data } = props;

  return <IndexPageTemplate data={data} />;
};

export default IndexPage;
